module.exports = __webpack_public_path__ + "static/Symphonia7-525cdd386d80f3a1a73e2f833664e46d.webp";